import { Map } from "immutable";

import { UserMapper } from "app/app.mappers";
import { ACTIONS } from "features/planner/planner.constants";

const initialState = Map();

export default (state = initialState, action) => {
  const { error, payload, type } = action;

  switch (type) {
    case ACTIONS.GET_USERS: {
      if (error) return state;

      return Map(
        payload.map(User => [User.userId.toString(), UserMapper.from(User)]),
      );
    }

    case ACTIONS.UPDATE_USER: {
      if (error) return state;

      return state.set(payload.userId.toString(), UserMapper.from(payload));
    }

    default:
      return state;
  }
};
